{
  "version": 1,
  "asset_id": "51d86337-21e2-4033-bac4-d652fc030bcd",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/51d86337-21e2-4033-bac4-d652fc030bcd/svc-saas-seo-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/51d86337-21e2-4033-bac4-d652fc030bcd/svc-saas-seo-1200.webp",
  "original_filename": "svc-saas-seo-1200.webp",
  "size": 16310,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:58Z"
}
